import React from 'react';
import {Popup, Layout, Icon, Icons} from 'components';
import {noop, every, first, last, useNamedSelector, openPopup, useLocation} from 'helpers';
import {set} from 'store/settings';
import {navigate} from 'store/calendar';
import css from './toolbar.module.scss';

export function Toolbar() {
  const { today } = useNamedSelector('calendar.days');
  const { updatesCount } = useNamedSelector('settings.ui');
  const { fullscreen, dates, currentDate } = useNamedSelector('calendar.settings');
  const step = dates.length == 7 ? 7 : 1;
  const prev = () => navigate(currentDate.clone().add(-1*step, 'day'));
  const next = () => navigate(currentDate.clone().add(+1*step, 'day'));
  return useLocation().pathname == '/today/' && (
    <Layout.Topbar.Toolbar>
      <i className="show-for-xxlarge" />
      { every(dates, date => !date.isSame(today)) &&
        <Icons.Return className="show-for-xxlarge" onClick={() => navigate(today)} />
      }
      <span className={css('period', 'show-for-xxlarge')}>{first(dates).range(last(dates))}</span>
      {/*<Icons.ChevronLeft onClick={prev} className={css('chevron', 'show-for-xxlarge')} />
      <Icons.ChevronRight onClick={next} className={css('chevron', 'show-for-xxlarge')} />
      <i />*/}
      { updatesCount > 0 &&
        <Icons.Gift to="/settings/whats-new/" Sub={Icons.Exclamation} warning />
      }
      <Icons.Today className={css('icon')} Sub={Icons.Gear} onClick={openPopup(Options)} />
      <Icon name={fullscreen ? 'collapse' : 'fullscreen'} onClick={() => set({ module: 'today', key: 'fullscreen', value: !fullscreen })} />
    </Layout.Topbar.Toolbar>
  );
}

function Options() {
  const { dates } = useNamedSelector('calendar.settings');
  return (
    <Popup.Menu onClick={noop}>
      <Popup.Menu.SubHeading>View</Popup.Menu.SubHeading>
      <Popup.Menu.Item pressed={dates.length == 1} onClick={() => set({ module: 'today', key: 'period', value: 'one-day' })} value="one-day">1 Day</Popup.Menu.Item>
      <Popup.Menu.Item pressed={dates.length == 3} onClick={() => set({ module: 'today', key: 'period', value: 'three-days' })} value="three-days">3 Days</Popup.Menu.Item>
      <Popup.Menu.Item pressed={dates.length == 7} onClick={() => set({ module: 'today', key: 'period', value: 'week' })} value="week">1 Week</Popup.Menu.Item>
    </Popup.Menu>
  );
}
